import { useContext, useState } from "react";
import { format as dateFnsFormat } from "date-fns";
import useAPIRequest from "../../../custom_hooks/simple/useAPIRequest";
import UiContext from "../../../store/ui-context";
import { useAPIGetVacation } from "./api-get-vacation";

export const useAPIGetAttendance = () => {
  const uiContext = useContext(UiContext);
  const { requestGet, loading } = useAPIRequest();
  const { fetchVacationsByDate, buildVacationMap } = useAPIGetVacation();

  const [selectedDate, setSelectedDate] = useState(new Date());
  const [listData, setListData] = useState([]);
  const [selectedIds, setSelectedIds] = useState([]);
  const [vacationMap, setVacationMap] = useState({});

  const [filterValue, setFilterValue] = useState({
    nama: "",
  });

  // API call section

  const fetchListData = async (date, filter) => {
    const dateString = dateFnsFormat(date ?? selectedDate, "yyyy-MM-dd");
    const newFilter = filter ?? getFilter(filterValue);

    return requestGet({
      fullUrl: `/api/masterdata/attendance/get-daily`,
      params: {
        date: dateString,
        filter: newFilter
      },
      onSuccess: async ({ message, data }) => {
        // Fetch vacation data for the selected date
        const vacationData = await fetchVacationsByDate(dateString);
        const newVacationMap = buildVacationMap(vacationData);
        setVacationMap(newVacationMap);

        const mappedData = data.map((el) => ({
          ...el,
          checked: false,
          is_on_vacation: newVacationMap.hasOwnProperty(el.employee_id),
          vacation_data: newVacationMap[el.employee_id] || null,
        }));

        setListData(mappedData);
        setSelectedIds([]);
      },
      onError: ({ message }) => {
        uiContext.showErrorMsg("Error", message);
      },
    });
  };

  const getFilter = (_filterValue) => {
    const filterArr = [];

    const newFilterValue = _filterValue ?? filterValue;

    if (newFilterValue.nama) {
      filterArr.push(`data_employee.name:contains:${newFilterValue.nama}`);
    }

    return filterArr.join(";");
  };

  // UI Handler section

  const handleOnClickRefresh = () => {
    fetchListData(selectedDate);
  };

  const handleToggleCheckbox = (id) => {
    const updatedList = listData.map((item) => {
      if (item.id === id) {
        return {
          ...item,
          checked: !item.checked,
        };
      }
      return item;
    });
    setListData(updatedList);

    // Update selected IDs
    const item = listData.find((el) => el.id === id);
    if (item.checked) {
      // Was checked, now unchecked
      setSelectedIds(selectedIds.filter((selectedId) => selectedId !== id));
    } else {
      // Was unchecked, now checked
      setSelectedIds([...selectedIds, id]);
    }
  };

  const getSelectedData = () => {
    const dateString = dateFnsFormat(selectedDate, "yyyy-MM-dd");
    return listData
      .filter((item) => item.checked && item.employee_id)
      .map((item) => ({
        id: item.id,
        employee_id: item.employee_id,
        date: item.date || dateString,
        attend: item.attend,
        keterangan: item.keterangan || null,
      }));
  };

  return {
    loading,
    listData,
    selectedDate,
    setSelectedDate,
    selectedIds,
    fetchListData,
    handleOnClickRefresh,
    handleToggleCheckbox,
    getSelectedData,
    filterValue,
    setFilterValue,
    vacationMap,
  };
};
